<template>
  <div class="col-12">
    <div class="col-12 q-my-lg">
      <adicionar-modelo :unidadeId="unidade.id" @atualizar="atualizarTodos" />
    </div>
    <div class="col-12 q-ml-sm">
      <p class="text-brand-5 text-weight-bold q-ml-md titulo-table">
        Modelos Atuais
      </p>
    </div>
    <div class="col-12">
      <q-table
        table-header-class="bg-accent text-weight-bold"
        :rows="listaModelos"
        :columns="columns"
        :grid="$q.screen.lt.sm"
        v-model:pagination="pagination"
        :loading="loading"
        dense
        @request="handleRequest"
        hide-pagination
        flat
        color="primary"
        class="tabela-tamanho-fixo"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4">
            <div class="row card q-mb-md">
              <div class="col-12 q-mr-sm q-mt-sm">
                <div
                  class="row text-brand-5 text-grid-table text-brand-5 q-pa-md"
                >
                  <div class="row col-12">
                    <span class="q-mr-xs"
                      ><strong>Nome do Modelo:</strong>
                      {{ props.row.modeloNome }}</span
                    >
                  </div>
                  <div class="row col-12">
                    <span class="q-mr-xs"
                      ><strong>Criador:</strong>
                      {{ props.row.criadorNome }}</span
                    >
                  </div>
                  <div class="row col-12 q-mt-sm">
                    <q-btn
                      label="Detalhar"
                      color="primary"
                      flat
                      no-caps
                      class="btn btn-detalhar-mobile"
                      @click="detalharModelo(props.row.modeloId)"
                    />
                    <q-btn
                      label="Duplicar"
                      color="orange"
                      flat
                      no-caps
                      class="btn btn-duplicar-mobile q-ml-sm"
                      @click="abrirModalDuplicar(props.row)"
                    />
                    <q-btn
                      label="Remover"
                      color="red"
                      no-caps
                      flat
                      class="btn btn-remover-mobile q-ml-sm"
                      style="color: white; background: #cf1515"
                      @click="abrirModalConfirmarExclusao(props.row)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-nome="props">
          <q-td class="text-brand-4 text-weigth-bold" :props="props">
            {{ props.row.modeloNome }}
          </q-td>
        </template>
        <template v-slot:body-cell-criador="props">
          <q-td class="text-brand-4 text-weight-medium" :props="props">
            {{ props.row.criadorNome }}
          </q-td>
        </template>
        <template v-slot:body-cell-detalhar="props">
          <q-td :props="props">
            <q-btn
              color="primary"
              text-color="white"
              icon="visibility"
              round
              @click="detalharModelo(props.row.modeloId)"
            >
              <q-tooltip>Ver Detalhes</q-tooltip>
            </q-btn>
          </q-td>
        </template>
        <template v-slot:body-cell-duplicar="props">
          <q-td :props="props">
            <q-btn
              color="secondary"
              text-color="white"
              icon="content_copy"
              round
              @click="abrirModalDuplicar(props.row)"
            >
              <q-tooltip>Duplicar Modelo</q-tooltip>
            </q-btn>
          </q-td>
        </template>
        <template v-slot:body-cell-remover="props">
          <q-td :props="props">
            <q-btn
              color="red"
              text-color="white"
              icon="delete"
              round
              @click="abrirModalConfirmarExclusao(props.row)"
            >
              <q-tooltip>Remover Modelo</q-tooltip>
            </q-btn>
          </q-td>
        </template>
      </q-table>
    </div>

    <q-dialog v-model="modalDuplicar" persistent>
      <q-card style="min-width: 400px">
        <q-card-section>
          <div class="text-h6">Duplicar Modelo</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <div class="q-mb-md">
            <div class="text-subtitle2 q-mb-xs">Modelo a ser duplicado:</div>
            <div class="text-body2 text-grey-7">
              {{ modeloSelecionado?.modeloNome }}
            </div>
          </div>

          <div class="q-mb-md">
            <div class="text-subtitle2 q-mb-xs">Unidade de destino:</div>
            <q-select
              outlined
              dense
              v-model="unidadeDestino"
              :options="listaUnidades"
              option-label="nome"
              option-value="id"
              label="Selecione a unidade"
              :rules="[(val) => val || 'Selecione uma unidade']"
            />
          </div>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            flat
            label="Cancelar"
            color="primary"
            @click="fecharModalDuplicar"
          />
          <q-btn
            label="Duplicar"
            color="primary"
            @click="duplicarModelo"
            :loading="loadingDuplicar"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog v-model="modalConfirmarExclusao" persistent>
      <q-card style="min-width: 400px">
        <q-card-section>
          <div class="text-h6 text-red">Confirmar Exclusão</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <div class="text-body1">
            Tem certeza de que deseja excluir o modelo
            <strong>"{{ modeloParaExcluir?.modeloNome }}"</strong>?
          </div>
          <div class="text-body2 text-grey-7 q-mt-sm">
            Esta ação não pode ser desfeita.
          </div>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            flat
            label="Cancelar"
            color="primary"
            @click="fecharModalConfirmarExclusao"
          />
          <q-btn
            label="Excluir"
            color="red"
            @click="confirmarExclusao"
            :loading="loadingExcluir"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useQuasar } from "quasar";
import AdicionarModelo from "./AdicionarModelo.vue";

export default {
  components: { AdicionarModelo },
  setup() {
    const store = useStore();
    const router = useRouter();
    const quasar = useQuasar();

    const columns = [
      {
        name: "nome",
        required: true,
        label: "Nome do Modelo",
        align: "left",
        field: "modeloNome",
        format: (val) => `${val}`,
        sortable: true,
      },
      {
        name: "criador",
        align: "left",
        label: "Criador",
        field: "criadorNome",
        sortable: true,
      },
      {
        name: "detalhar",
        label: "Detalhar",
        align: "center",
        field: "modeloId",
        sortable: false,
      },
      {
        name: "duplicar",
        label: "Duplicar",
        align: "center",
        field: "modeloId",
        sortable: false,
      },
      {
        name: "remover",
        label: "Remover",
        align: "center",
        field: "modeloId",
        sortable: false,
      },
    ];

    const unidade = ref("");
    const listaModelos = ref([]);
    const listaUnidades = ref([]);
    const modalDuplicar = ref(false);
    const modeloSelecionado = ref(null);
    const unidadeDestino = ref(null);
    const loadingDuplicar = ref(false);
    const modalConfirmarExclusao = ref(false);
    const modeloParaExcluir = ref(null);
    const loadingExcluir = ref(false);

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 6,
    });
    const loading = ref(true);
    const disable = ref(false);

    const listarModelos = async () => {
      try {
        const resposta = await store.dispatch("pdt/listarModelos", {
          unidadeId: unidade.value.id,
        });

        listaModelos.value = resposta.data.resultado.dados || [];
        pagination.value.rowsNumber = listaModelos.value.length;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.error("Erro ao listar modelos:", error);
        loading.value = false;
        disable.value = false;
      }
    };

    const listarUnidades = async () => {
      try {
        const resposta = await store.dispatch("org/listarUnidades");
        listaUnidades.value = resposta.listaUnidades.filter(
          (u) => u.id !== unidade.value.id
        );
      } catch (error) {
        console.error("Erro ao listar unidades:", error);
      }
    };

    const detalharModelo = (modeloId) => {
      router.push({
        name: "pdt-modelo-detalhe",
        params: { modeloId },
      });
    };

    const abrirModalDuplicar = (modelo) => {
      modeloSelecionado.value = modelo;
      unidadeDestino.value = null;
      modalDuplicar.value = true;
    };

    const fecharModalDuplicar = () => {
      modalDuplicar.value = false;
      modeloSelecionado.value = null;
      unidadeDestino.value = null;
    };

    const duplicarModelo = async () => {
      if (!unidadeDestino.value) {
        quasar.notify({
          message: "Selecione uma unidade de destino",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });
        return;
      }

      try {
        loadingDuplicar.value = true;

        const resposta = await store.dispatch("pdt/duplicarModelo", {
          modeloId: modeloSelecionado.value.modeloId,
          unidadeDestinoId: unidadeDestino.value.id,
        });

        quasar.notify({
          message:
            resposta.data.resultado.mensagem || "Modelo duplicado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });

        fecharModalDuplicar();
      } catch (error) {
        console.error("Erro ao duplicar modelo:", error);
        quasar.notify({
          message: "Erro ao duplicar modelo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });
      } finally {
        loadingDuplicar.value = false;
      }
    };

    const abrirModalConfirmarExclusao = (modelo) => {
      modeloParaExcluir.value = modelo;
      modalConfirmarExclusao.value = true;
    };

    const fecharModalConfirmarExclusao = () => {
      modalConfirmarExclusao.value = false;
      modeloParaExcluir.value = null;
    };

    const confirmarExclusao = async () => {
      try {
        loadingExcluir.value = true;
        await store.dispatch("pdt/removerModelo", {
          modeloId: modeloParaExcluir.value.modeloId,
        });
        quasar.notify({
          message: "Modelo removido com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });
        listarModelos();
        fecharModalConfirmarExclusao();
      } catch (error) {
        console.error("Erro ao remover modelo:", error);
        quasar.notify({
          message: "Erro ao remover modelo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });
      } finally {
        loadingExcluir.value = false;
      }
    };

    const handleRequest = async () => {
      listarModelos(pagination.value.page, pagination.value.rowsPerPage);
    };

    const atualizarTodos = async () => {
      listarModelos();
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value = store.state.org.unidadeData;
        if (unidade.value) {
          listarModelos();
          listarUnidades();
        }
      }
    );

    const getUnidade = () => {
      if (!store.state.org.unidadeData) {
        return;
      }
      unidade.value = store.state.org.unidadeData;
      listarModelos();
      listarUnidades();
    };

    onMounted(getUnidade);

    return {
      unidade,
      listaModelos,
      listaUnidades,
      columns,
      pagination,
      loading,
      disable,
      modalDuplicar,
      modeloSelecionado,
      unidadeDestino,
      loadingDuplicar,
      modalConfirmarExclusao,
      modeloParaExcluir,
      loadingExcluir,
      listarModelos,
      detalharModelo,
      abrirModalDuplicar,
      fecharModalDuplicar,
      duplicarModelo,
      abrirModalConfirmarExclusao,
      fecharModalConfirmarExclusao,
      confirmarExclusao,
      handleRequest,
      atualizarTodos,
    };
  },
};
</script>

<style scoped>
.titulo-table {
  font-size: 17px;
}

@media (max-width: 600px) {
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .btn {
    border-radius: 0px;
    font-size: 11px;
  }
  .text-grid-table {
    font-size: 11px;
  }
  .titulo-table {
    font-size: 14px;
    margin: 0px 0px 10px 0px;
  }
  .btn-remover-mobile {
    min-height: 45px !important;
  }
}

@media (max-width: 480px) {
  .btn-remover-mobile {
    min-height: 45px !important;
  }
}
</style>
